import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ReactSVG } from 'react-svg';
import image from '../../../assets/image/welcome/slide1.svg';
import CustomBtn from '../../../generic/CustomBtn';
import { ContextForm } from '../../../utils/projectRegistration';
import storage from '../../../utils/storage';

const TwoProjectPathways = () => {
  const translate = useIntl();
  const { formData, setFormData } = useContext(ContextForm);

  const mrvProject = () => {
    storage.set('isInterest', {
      project_id: '',
      isInterest: false,
    });
    setFormData({ ...formData, isProjectRegisterForm: false });
  };

  const carbonProject = () => {
    storage.set('isInterest', {
      project_id: '',
      isInterest: true,
    });
    setFormData({ ...formData, isProjectRegisterForm: false });
  };

  return (
    <div className="project-register__twoProjectPathways">
      <ReactSVG src={image} className="welcome__image" />
      <h2 className="project-register__title">
        {translate.formatMessage({ id: 'project-register.launchANewProject' })}
      </h2>
      <FormattedMessage
        id="project-register.twoProjectPathwaysDescription"
        values={{
          p: (...chunks) => <p className="project-register__subtitle">{chunks}</p>,
          br: <br />,
        }}
      />
      <div className="project-register__buttonsWrapper">
        <CustomBtn
          label={translate.formatMessage({ id: 'button-mrv' })}
          type="button"
          handleClick={() => mrvProject()}
          customClass="btn__btn-next"
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'button-carbon' })}
          type="button"
          handleClick={() => carbonProject()}
          customClass="btn__btn-next"
        />
      </div>
    </div>
  );
};

export default TwoProjectPathways;
